export const TYPOGRAPHY = {
    'font-familia-base': "'Inter', system-ui, sans-serif",
    'font-familia-mono': "'JetBrains Mono', ui-monospace, monospace",
    'font-familia-display': "'Space Grotesk', 'Inter', system-ui, sans-serif",
    'font-size-xs': '0.75rem',
    'font-size-sm': '0.875rem',
    'font-size-base': '1rem',
    'font-size-lg': '1.125rem',
    'font-size-xl': '1.5rem',
    'font-size-2xl': '2rem',
    'font-weight-regular': '400',
    'font-weight-medio': '500',
    'font-weight-semibold': '600',
    'font-weight-bold': '700',
    'line-height-apertado': '1.2',
    'line-height-base': '1.5',
};
//# sourceMappingURL=typography.js.map